export default __webpack_public_path__ + "static/media/views_right.f168f737.svg";